// Display label for a topic picker. The stored name is only the leaf; the
// ancestors in `path` are joined in front so the list and its search can tell
// same-named topics apart. Root topics stay as their name alone.
const SEP = ' / '

function idOf(value) {
  if (value == null) return ''
  if (typeof value === 'object') return String(value._id || '')
  return String(value)
}

export function topicLabelFor(topics) {
  const byId = new Map((topics || []).map((topic) => [String(topic._id), topic]))
  return (topic) => {
    if (!topic) return ''
    const full = byId.get(String(topic._id)) || topic
    const names = []
    for (const ancestorId of full.path || []) {
      const ancestor = byId.get(idOf(ancestorId))
      const name = ancestor?.name || (ancestorId && typeof ancestorId === 'object' ? ancestorId.name : '')
      if (name) names.push(name)
    }
    names.push(full.name || topic.name || 'Topic')
    return names.join(SEP)
  }
}
